import Signin from '../../components/uicontainers/public/signin';

export default function SignInPage() {
  return (
    <>
      <Signin />
    </>
  );
}
